<template>
  <div>
    <AcordeonTable 
      :criterios="[criterios]"
    />
    <v-divider class="my-5" />
    <div class="d-flex align-center justify-end">
      <botao-padrao
        :disabled="getErros.length > 0"
        :title="getErros.length > 0? 'É necessário adicionar mensagens conforme critérios' : ''"
        @click="confirmacaoSalvar"
      >
        <v-icon>$mdiContentSaveOutline</v-icon>
        {{ $t('geral.botoes.salvar') }}
      </botao-padrao>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AcordeonTable from './tables/AcordeonTable.vue';

export default {
  components: {
    AcordeonTable
  },
  props:{
    criterios:[]
  },
  data() {
    return {
      moc: 
      [
        {
          "id": "",
          "sequencia": 1,
          "operadorLogico": "Ou",
          "tipoCriterio": "ServicoManutencao",
          "operadorRelacional": "Igual",
          "tipoOrcamento": null,
          "tipoContrato": null,
          "valorTotalOrcamento": null,
          "requisitoParticipante": null,
          "servicoCalibracao": {
            "id": null,
            "codigo": null
          },
          "tipoCalibracao": {
            "id": null,
            "nome": null,
            "apelido": null
          },
          "servicoManutencao": {
            "id": "null",
            "codigo": 'null'
          },
          "item": {
            "id": null,
            "descricao": null
          },
          "localExecucao": {
            "id": null,
            "nome": null
          },
          "participanteConta": {
            "id": null,
            "nome": null,
            "apelido": null
          },
          "tipoInstrumento": {
            "id": null,
            "nome": null
          },
          "campoAdicionalInstrumento": {
            "id": null,
            "nome": null
          },
          "campoAdicionalParticipante": {
            "id": null,
            "nome": null
          }
        }
      ]
      ,
      valores:[{
        "numeroItem": null,
        "sequencia": 1,
        "operadorLogico": null,
        "tipoCriterio": "",
        "operadorRelacional": null,
        "tipoValor": null,
        "tipoValorLogico": false,
        "tipoValorNumerico": false,
        "tipoValorPercentual": false,
        "valorNumerico": null,
        "valorPercentual": null,
        "valorLogico": null,
        "valor": null,
        "itemId": null,
      }]
    };
  },
  computed: {
    ...mapGetters('criterios', ['getCriterios', 'getErros'])
  },
  mounted() {
    this.setup()
  },
  methods:{
    setup(){
      this.$store.dispatch('criterios/validarCriterios');
    },
    getError(){
      return this.$store.state.criterios.erros;
    },
    confirmacaoSalvar(){
      this.$emit('submit-criterios')
    },
    retornoValores(valor){
      this.$emit('retornoValores', valor);
    },
    validarCriterios() {
      this.$store.dispatch('criterios/validarCriterios');
    }
  }
};
</script>
